import { z } from 'zod';

import { schemaISODateString } from '../../isISO8601';
import objectPassthrough from '../../objectPassthrough';
import { ISODateString } from '../../types';
import { ProtectedValue } from '../ProtectedValue';

interface ElsterCertificate {
  // The PKCS#12 file binary, base64 encoded and encrypted
  certificateData: ProtectedValue;
  // Original filename of the uploaded certificate
  filename: string;
  // Cached metadata extracted from certificate (for display without needing password)
  issuer: string;
  // ELSTER account number (CN from certificate subject)
  subjectCN: string;
  serialNumber: string;
  validFrom: ISODateString;
  validUntil: ISODateString;
}

const ElsterCertificate = objectPassthrough({
  certificateData: ProtectedValue,
  filename: z.string(),
  issuer: z.string(),
  subjectCN: z.string(),
  serialNumber: z.string(),
  validFrom: schemaISODateString,
  validUntil: schemaISODateString,
});

export { ElsterCertificate };
